import { render, staticRenderFns } from "./ModalNotificacao.vue?vue&type=template&id=ad225fb4&scoped=true"
import script from "./ModalNotificacao.vue?vue&type=script&lang=js"
export * from "./ModalNotificacao.vue?vue&type=script&lang=js"
import style0 from "./ModalNotificacao.vue?vue&type=style&index=0&id=ad225fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad225fb4",
  null
  
)

export default component.exports